export const localStorageEnums = {
    TOKEN: "token",
    PHONE: "phone",
}